import { call, put, takeEvery } from 'redux-saga/effects';
import {
  emailVerificationRequest,
  emailVerificationSuccess,
  emailVerificationFailure
} from '../actions/emailVerificationActions';
import { emailVerificationApi } from '../../api/emailVerificationApi';
import { toast } from 'react-toastify';

function* emailVerificationSaga(action) {
  try {
    yield put(emailVerificationRequest());
    
    const { token, email } = action.payload;
    const data = yield call(emailVerificationApi.verifyEmail, token, email);
    
    const message = data.message || 'Email verified successfully!';
    yield put(emailVerificationSuccess(message));
    toast.success(message);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Email verification failed. Please try again.';
    yield put(emailVerificationFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* adminEmailVerificationSaga(action) {
  try {
    yield put(emailVerificationRequest());
    
    const { token, email } = action.payload;
    const data = yield call(emailVerificationApi.verifyEmail, token, email);
    
    const message = data.message || 'Email verified successfully!';
    yield put(emailVerificationSuccess(message));
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Email verification failed. Please try again.';
    yield put(emailVerificationFailure(errorMessage));
  }
}

function* watchEmailVerification() {
  yield takeEvery('EMAIL_VERIFICATION_SAGA', emailVerificationSaga);
  yield takeEvery('ADMIN_EMAIL_VERIFICATION_SAGA', adminEmailVerificationSaga);
}

export default watchEmailVerification;